import { FETCH_COMING_CARS } from '../../helpers/constants';
import { ActionType } from '../../interface/actionType';
import { ICar } from '../../interface/car';

export interface IComingCars {
    cars: ICar[];
    totalComing: number | null;
}

export interface IComingCarsState {
    incomingCars: IComingCars;
}

const initialState: IComingCarsState = {
    incomingCars: {
        cars: [],
        totalComing: null
    }
};

const FetchComingCarsReducer = (
    state = initialState,
    action: ActionType
): IComingCarsState => {
    switch (action.type) {
        case FETCH_COMING_CARS:
            return {
                ...state,
                incomingCars: { ...state.incomingCars, ...action.payload }
            };

        default:
            return state;
    }
};

export default FetchComingCarsReducer;
